// extracted by mini-css-extract-plugin
module.exports = {"block":"Layout1_block__1dh3y","blockMedia":"Layout1_blockMedia__18aA3","assets":"Layout1_assets__UMokL"};